import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";

function PolicyPage({
  kicker = "Store policy",
  title,
  intro,
  lead,
  sections,
  related = [],
}) {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <main className="privacy policy-page">
      <header className="policy-page__hero">
        <p className="policy-page__kicker">{kicker}</p>
        <h1>{title}</h1>
        <p>{intro}</p>
        <span>Last updated {siteConfig.policies.lastUpdated}</span>
      </header>

      <div className="policy-page__layout">
        <nav className="policy-page__nav" aria-label={`${title} sections`}>
          <span>On this page</span>
          {sections.map((section) => (
            <a key={section.id} href={`#${section.id}`}>
              {section.navLabel || section.title}
            </a>
          ))}
        </nav>

        <article className="policy-page__content">
          <section className="policy-page__lead" aria-label={`${title} overview`}>
            <p>{lead}</p>
          </section>

          {sections.map((section, index) => (
            <section id={section.id} key={section.id}>
              <p className="policy-page__number">
                {String(index + 1).padStart(2, "0")}
              </p>
              <h2>{section.title}</h2>
              {section.content}
            </section>
          ))}

          {related.length > 0 && (
            <div className="policy-page__related">
              <span>Related policies</span>
              {related.map((item) => (
                <Link key={item.path} to={item.path} onClick={toTop}>
                  {item.label}
                </Link>
              ))}
            </div>
          )}
        </article>
      </div>
    </main>
  );
}

export default PolicyPage;
